import { CloseIcon } from 'assets/svgs';
import { Modal } from 'components/common';
import React, { useRef } from 'react';
import ReactPlayer from 'react-player';
import styles from './videomodal.module.scss';
export default function VideoModal({ url, showModal, handleClose }) {
  const ref = useRef();
  const stopAndCloseVideo = () => {
    const seekTo = ref.current?.seekTo;
    seekTo(0);
    handleClose();
  };
  return (
    <Modal showModal={showModal} maxWidth={640} handleClose={handleClose} plain>
      <button
        className={styles.close}
        type="button"
        onClick={stopAndCloseVideo}
      >
        <CloseIcon className={styles.icon} />
      </button>

      <ReactPlayer
        ref={ref}
        url={url}
        width="100%"
        height="400px"
        controls={true}
      />
    </Modal>
  );
}
